<p-dialog
	[style]="{ width: '620px' }"
	[modal]="true"
	styleClass="p-fluid"
	[(visible)]="!!messageId"
	(onHide)="resetAndClose()">
	<ng-template pTemplate="content">
		<div *ngIf="showSendSummary">
			<div *ngIf="message.destinataires.length > 0" class="mb-6">
				<div class="flex flex-row align-items-center gap-2 mb-3">
					<i
						class="pi pi-check"
						style="font-size: 1.5rem; font-weight: bold; color: #29c76f; margin-right: 10px"></i>
					<span>{{ "message.success-destinataires-valid" | translate }}</span>
				</div>
				<p-table [value]="message.destinataires" responsiveLayout="scroll">
					<ng-template pTemplate="header">
						<tr>
							<th>{{ "message.summary-table.cheptel" | translate }}</th>
							<th>{{ "message.summary-table.email" | translate }}</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-destinataire>
						<tr>
							<td>{{ destinataire.numeroCheptel }}</td>
							<td>{{ destinataire.email }}</td>
						</tr>
					</ng-template>
				</p-table>
			</div>

			<div *ngIf="failedDestinataires.length > 0">
				<div class="flex flex-row align-items-center gap-2 mb-3">
					<i
						class="pi pi-exclamation-triangle"
						style="font-size: 1.5rem; font-weight: bold; color: red; margin-right: 10px"></i>
					<span>{{ "message.error-destinataires-invalid" | translate }}</span>
				</div>
				<p-table [value]="failedDestinataires" responsiveLayout="scroll">
					<ng-template pTemplate="header">
						<tr>
							<th>{{ "message.summary-table.cheptel" | translate }}</th>
							<th>{{ "message.summary-table.email" | translate }}</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-destinataire>
						<tr>
							<td>{{ destinataire.numeroCheptel }}</td>
							<td>{{ destinataire.email }}</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
		<div *ngIf="!showSendSummary">
			<form [formGroup]="editForm" (ngSubmit)="onSave()">
				<h5>{{ "message.destinataires" | translate }}</h5>
				<div *ngIf="fileDestinataires.length === 0">
					<div class="one-input">
						<h6>
							{{ "message.destinataires-unique" | translate }}
						</h6>
						<div class="formgrid grid flex align-items-center" style="margin-bottom: 1rem">
							<div class="col-5">
								<input
									type="text"
									pInputText
									formControlName="uniqueDestinataireNumeroCheptel"
									minLength="2"
									maxlength="20"
									placeholder="{{ 'cheptel.numero' | translate }}"
									required />
							</div>
							<div class="col-7">
								<input
									type="text"
									pInputText
									formControlName="uniqueDestinataireEmail"
									maxlength="200"
									placeholder="{{ 'global.email' | translate }}"
									required />
							</div>
						</div>
					</div>
					<div class="file-input">
						<h6>
							{{ "message.destinataires-file" | translate }}
						</h6>
						<input
							type="file"
							name="import-csv"
							id="import-csv"
							class="file-input__input"
							accept=".csv"
							(change)="importDataFromCSV($event)" />
						<label class="flex justify-content-center input-csv-button file-input__label" for="import-csv">
							<i class="pi pi-plus"></i>
							<span>{{ "message.import-csv" | translate }}</span>
						</label>
					</div>
					<div class="template-info-container">
						<p class="gray-message" style="max-width: 55%">
							{{ "message.info-text-destinataires" | translate }}
						</p>
						<button
							pButton
							type="button"
							style="max-width: 40%"
							label="{{ 'message.download-template' | translate }}"
							(click)="downloadTemplateFile()"
							class="p-button-text p-button-success"></button>
					</div>
				</div>

				<div *ngIf="fileDestinataires.length > 0" class="template-info-container">
					<i class="pi pi-check" style="font-size: 1.5rem; font-weight: bold; color: #29c76f"></i>
					<div>
						<div class="flex flex-row">
							<span style="font-size: 15px; font-weight: 700; margin-right: 5px">{{
								fileDestinataires.length
							}}</span>
							<span>{{ "message.imported-destinataires" | translate }}</span>
						</div>
						<p style="font-size: 0.75rem; color: #7e8691">
							{{ "message.warn-text" | translate }}
						</p>
					</div>
					<button
						pButton
						pRipple
						type="button"
						icon="pi pi-download"
						(click)="downloadDestinataires()"
						class="p-button-rounded p-button-secondary"></button>
					<button
						pButton
						pRipple
						type="button"
						icon="pi pi-trash"
						(click)="resetDestinataires()"
						class="p-button-rounded p-button-danger"></button>
				</div>

				<h5>
					{{ "message.message-section" | translate }}

					<span *ngIf="isCurrentlyVisible" class="message-visibility status-active">
						{{ "message.visibilite-ok" | translate }}
					</span>
					<span *ngIf="!isCurrentlyVisible" class="message-visibility status-desactive">
						{{ "message.visibilite-nok" | translate }}
					</span>
				</h5>
				<div class="flex flex-row justify-content-between gap-2 w-full">
					<div class="field">
						<h6>
							<label for="start">{{ "message.send-date" | translate }}</label>
						</h6>
						<p-calendar
							id="start"
							formControlName="dateVisibilite"
							[readonlyInput]="true"
							placeholder="JJ/MM/AAAA"
							dateFormat="dd/mm/yy"
							showIcon="true"
							(onSelect)="setVisibilityBadge()"
							appendTo="body"></p-calendar>
					</div>
					<div class="field">
						<h6>
							<label for="end">{{ "message.expire-date" | translate }}</label>
						</h6>
						<p-calendar
							id="end"
							formControlName="dateExpiration"
							[readonlyInput]="true"
							placeholder="JJ/MM/AAAA"
							dateFormat="dd/mm/yy"
							showIcon="true"
							(onSelect)="setVisibilityBadge()"
							appendTo="body"></p-calendar>
					</div>
				</div>

				<div class="field">
					<h6>{{ "message.titre" | translate }}*</h6>
					<input
						type="text"
						pInputText
						formControlName="titre"
						maxlength="200"
						placeholder="{{ 'message.title-placeholder' | translate }}"
						required />

					<div *ngIf="form.titre.errors && (form.titre.dirty || form.titre.touched)" class="invalid-form">
						<div *ngIf="form.titre.errors.required">{{ "global.required" | translate }}</div>
						<div *ngIf="form.titre.errors.minlength">{{ "message.titre-min-length" | translate }}</div>
						<div *ngIf="form.titre.errors.maxlength">{{ "message.titre-max-length" | translate }}</div>
					</div>
				</div>

				<div class="field">
					<h6>{{ "message.corps" | translate }}*</h6>
					<textarea
						style="resize: none"
						pInputTextarea
						formControlName="corps"
						[rows]="7"
						maxlength="20000"
						placeholder="{{ 'message.message-placeholder' | translate }}"
						required></textarea>

					<div *ngIf="form.corps.errors && (form.corps.dirty || form.corps.touched)" class="invalid-form">
						<div *ngIf="form.corps.errors.required">{{ "global.required" | translate }}</div>
						<div *ngIf="form.corps.errors.minlength">{{ "message.corps-min-length" | translate }}</div>
						<div *ngIf="form.corps.errors.maxlength">{{ "message.corps-max-length" | translate }}</div>
					</div>
				</div>
				<div class="flex flex-row justify-content-end w-full">
					<button
						pButton
						pRipple
						type="submit"
						style="width: 30%"
						label="{{ 'message.send-button' | translate }}"
						class="p-button-success m-0"
						[disabled]="!formIsValid"></button>
				</div>
			</form>
		</div>
	</ng-template>
	<ng-template pTemplate="footer"></ng-template>
</p-dialog>
